import type { BetOptions, BetType, TableRules, TableState } from './types.js';

export interface Legality {
  allowed: boolean;
  reason?: string;
}

const ok = (): Legality => ({ allowed: true });
const no = (reason: string): Legality => ({ allowed: false, reason });

const REQUIRES_NUMBER = new Set<BetType>(['place', 'buy', 'lay', 'hardway']);

export function canPlaceBet(
  type: BetType,
  opts: BetOptions,
  state: TableState,
  _rules: TableRules,
): Legality {
  if (REQUIRES_NUMBER.has(type) && opts.number === undefined) {
    return no(`${type} requires a number (4/5/6/8/9/10)`);
  }
  if (type === 'hop' && !opts.hopFaces) {
    return no('hop requires hopFaces (e.g., [3, 3] for hard hop 6)');
  }
  if (type === 'pass' || type === 'dontPass') {
    return state.phase === 'COME_OUT'
      ? ok()
      : no("Pass/Don't Pass can only be placed at come-out (use Come during point phase)");
  }
  if (type === 'come' || type === 'dontCome') {
    return state.phase === 'POINT'
      ? ok()
      : no("Come/Don't Come are only available during point phase");
  }
  if (type === 'odds' || type === 'dontOdds') {
    if (!opts.parentBetId) return no('odds requires a parent line bet');
    const parent = state.bets.find((b) => b.id === opts.parentBetId);
    if (!parent) return no('parent bet not found');
    if (parent.type === 'pass' || parent.type === 'dontPass') {
      return state.phase === 'POINT' ? ok() : no('parent line bet does not have a point yet');
    }
    if (parent.type === 'come' || parent.type === 'dontCome') {
      return parent.number !== undefined
        ? ok()
        : no('parent come bet has not travelled to a number yet');
    }
    return no('odds parent must be a line or come bet');
  }
  return ok();
}
